<app-page-loader></app-page-loader>
<app-default *ngIf="dataInitialized"></app-default>
<app-job-reservation-fail *ngIf="!dataInitialized && isjobReservationFailed"></app-job-reservation-fail>

